import { useCallback } from 'react';
import { useMqttStore } from '../stores/mqttStore';
import * as mqttService from '../services/mqttService';

type UseMqttPublishOptions = {
  qos?: 0 | 1 | 2;
};

const useMqttPublish = (options?: UseMqttPublishOptions) => {
  const { qos: defaultQos = 1 } = options ?? {};
  const isConnected = useMqttStore(state => state.isConnected);

  const publish = useCallback(
    (topic: string, payload: string | object, qos?: 0 | 1 | 2) => {
      const message =
        typeof payload === 'string' ? payload : JSON.stringify(payload);
      mqttService.publish(topic, message, qos ?? defaultQos);
    },
    [defaultQos]
  );

  const publishCommand = useCallback(
    (topic: string, payload: string | object) => {
      const message =
        typeof payload === 'string' ? payload : JSON.stringify(payload);
      mqttService.publishCommand(topic, message);
    },
    []
  );

  return {
    publish,
    publishCommand,
    isConnected
  };
};

export default useMqttPublish;
